export const resolveViteRouterBasename = (): string | undefined => {
  const baseUrl = String(import.meta.env.BASE_URL || '/').trim()
  if (baseUrl === '/' || baseUrl.length === 0) {
    return undefined
  }

  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
}

export const resolvePublicAppBaseUrl = (configuredPublicAppBaseUrl: string): string => {
  const configured = String(configuredPublicAppBaseUrl || '').trim().replace(/\/+$/, '')
  if (configured) {
    return configured
  }

  if (typeof window === 'undefined') {
    return ''
  }

  const routerBasename = resolveViteRouterBasename()
  return `${window.location.origin}${routerBasename || ''}`.replace(/\/+$/, '')
}
